import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getRedoSuppliesOrder = {
  name: "getRedoSuppliesOrder" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({
    order: z.object({ _id: zExt.objectId() }).catchall(z.any()),
  }),
  mock: {
    order: {
      _id: "000000000000000000000001",
      extendedWarranties: [],
      finalSaleReturnsProtected: false,
      packageProtected: false,
      protected: false,
      customer_name: "Mock Customer",
      team: "000000000000000000000002",
      shopify_id: "mock-shopify-id",
      shopify: {
        name: "#1001",
        note: "",
        currency: "USD",
        created_at: new Date().toISOString(),
        financial_status: "paid",
        fulfillment_status: null,
        taxes_included: false,
        total_line_items_price: "100.00",
        total_tax: "0.00",
        total_discounts: "0.00",
        total_price: "100.00",
        line_items: [],
        shipping_lines: [],
        fulfillments: [],
        discount_codes: [],
        billing_address: null,
        shipping_address: null,
        customer: { id: "mock-customer-id", email: "mock@example.com" },
      },
    },
  },
};
